import React from "react";
import { useState } from "react";

import "./homeMainMenu.scss";
import arrow from "../../../SVG/RightArrow.svg";
import exit from "../../../SVG/ExitIcon.svg";
import modalOpen from "../../../SVG/ModalOpen.svg";

//
const HomeMainMenu = ({}) => {
  const [currentTab, setCurrentTab] = useState(0);

  const setTabIndex = (index) => {
    setCurrentTab(index);
  };

  const data = [
    {
      id: 1,
      title: "LA SEDE",
      subsections: [
        {
          titulo: "SOBRE NOSOTROS",
          url: "acercade/sobreNosotros",
        },
        {
          titulo: "GALERÍA",
          url: "acercade/galeria",
        },
        {
          titulo: "MISIÓN Y VISIÓN",
          url: "acercade/misionVision",
        },
        {
          titulo: "HISTORIA",
          url: "acercade/historia",
        },
        {
          titulo: "DIRECTORIO",
          url: "acercade/directorio",
        },
        {
          titulo: "MAPAS DE LA SEDE",
          url: "acercade/mapaSede",
        },
        {
          titulo: "DIRECCIÓN DE LA SEDE",
          url: "acercade/direccionSede",
        },
        {
          titulo: "DOCENTES",
          url: "acercade/docentes",
        },
        {
          titulo: "PLANEACIÓN",
          url: "acercade/planeacion",
        },
        {
          titulo: "RELACIONES INTERINSTITUCIONALES",
          url: "acercade/relacionesI",
        },
        {
          titulo: "SECRETARÍA DE SEDE",
          url: "acercade/secretariaSede",
        },
      ],
    },
    {
      id: 2,
      title: "FORMACIÓN",
      subsections: [
        {
          titulo: "PROGRAMAS ACADÉMICOS",
          url: "programas",
        },
      ],
    },
    {
      id: 3,
      title: "INVESTIGACIÓN",
      subsections: [
        {
          titulo: "GRUPOS DE INVESTIGACIÓN",
          url: "investigacion",
        },
        {
          titulo: "SEMILLEROS DE INVESTIGACIÓN",
          url: "semilleros",
        },
        {
          titulo: "LABORATORIOS",
          url: "laboratorios",
        },
      ],
    },
    {
      id: 4,
      title: "EXTENSIÓN",
      subsections: [
        {
          titulo: "EXTENSIÓN",
          url: "extension",
        },
        {
          titulo: "PROYECTOS",
          url: "proyectos",
        },
        {
          titulo: "CURSOS",
          url: "cursosdeextension",
        },
        {
          titulo: "DIPLOMADOS",
          url: "diplomados",
        },
      ],
    },
    {
      id: 5,
      title: "NOTICIAS",
      subsections: [
        {
          titulo: "EVENTOS DE LA SEDE",
          url: "calendario",
        },
        {
          titulo: "AGENCIA DE NOTICIAS UNAL",
          url: "http://agenciadenoticias.unal.edu.co/",
        },
        {
          titulo: "PERIÓDICO UNAL",
          url: "http://unperiodico.unal.edu.co/",
        },
        {
          titulo: "AL DÍA UNAL",
          url: "https://unal.edu.co/al-dia/",
        },
      ],
    },
    {
      id: 6,
      title: "TRAMITES ESTUDIANTILES",
      subsections: [
        {
          titulo: "VER TRAMITES ESTUDIANTILES",
          url: "tramites",
        },
      ],
    },
    {
      id: 7,
      title: "MENU",
      subsections: [
        {
          titulo: "MENU ROTATORIO",
          url: "menu",
        },
      ],
    },
  ];

  return (
    <>
      <div className="modalmain">
        <input id="modal" type="checkbox" className="modal--toggle" />
        <label htmlFor="modal" className="modal--toggle--text">
          <img src={modalOpen} className="modal--open--image"></img>
        </label>
        <div className="modal--container">
          <div className="modal--content">
            <label
              className="home-main-menu__exit-button modal--toggle--text "
              htmlFor="modal"
            >
              CERRAR <img src={exit} className="exit"></img>
            </label>
            <div className="home-main-menu__main-container">
              <div className="ellipse"></div>

              <div className="home-main-menu__menu-container">
                <div className="home-main-menu__main-tabs">
                  {data.map((value, index) => (
                    <button
                      key={index}
                      className={
                        currentTab === value.id
                          ? "home-main-menu__tab home-main-menu__tab--active"
                          : "home-main-menu__tab"
                      }
                      onClick={() => setTabIndex(value.id)}
                    >
                      {value.title}
                      <img src={arrow} className="arrow"></img>
                    </button>
                  ))}
                </div>
                <div className="home-main-menu__sub-tab">
                  <div className="home-main-menu__menu-middle-point"></div>
                  {data.map((value, index) => (
                    <div
                      key={index}
                      className={
                        currentTab === value.id
                          ? "home-main-menu__sub-tab-content  home-main-menu__sub-tab-content--active"
                          : "home-main-menu__sub-tab-content"
                      }
                    >
                      <ul className="home-main-menu__sub-tab-list">
                        {value.subsections.map((subvalue, index) => (
                          <li key={index}>
                            <a href={subvalue.url}>{subvalue.titulo}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeMainMenu;
